export const initialState = {
  increase_amount: '',
  minimum_purchase_amount: '',
  discount_percentage: '',
  full_price: '',
  suggested_retail_price: '',
  status: false,
  variants: null,
};
